import React from "react";
import Marquee from "react-fast-marquee";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

import { partnersMarqueeData } from "../model/constants";

export const PartnersMarquee: React.FC = () => {
  const theme = useTheme();

  const isLarge = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Stack width={1} direction="column" gap={8}>
      <Stack
        width={1}
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={1}
        sx={{
          flexWrap: {
            md: "nowrap",
            xs: "wrap",
          },
        }}
      >
        <Typography
          variant="h4"
          color="textSecondary"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          Successful
        </Typography>
        <Typography
          variant="h4"
          color="primary"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          Missions
        </Typography>
        <Typography
          variant="h4"
          color="textSecondary"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          With Industry
        </Typography>
        <Typography
          variant="h4"
          color="primary"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          Leaders
        </Typography>
      </Stack>

      <Marquee
        style={{
          background: "transparent",
          padding: "12px 0",
          flexShrink: 0,
          overflowY: "hidden",
          maxHeight: "90px",
        }}
        gradient
        gradientColor="#000000"
        pauseOnHover
      >
        {partnersMarqueeData.map((data) => {
          return (
            <img
              key={data.alt}
              src={data.image}
              alt={data.alt}
              height={isLarge ? 50 : 30}
              style={{
                objectFit: "contain",
                mixBlendMode: "multiply",
                margin: "0 32px",
                maxHeight: "50px",
              }}
            />
          );
        })}
      </Marquee>
    </Stack>
  );
};
